// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/location.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Track, TrackWithGeometry } from "./track_pb.js";
import { Point } from "./point_pb.js";

/**
 * @generated from message knop.ui.v1.model.Location
 */
export class Location extends Message<Location> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: repeated knop.ui.v1.model.Location.Junction junctions = 2;
   */
  junctions: Location_Junction[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.Location.BufferStop buffer_stops = 3;
   */
  bufferStops: Location_BufferStop[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.Location.TrackConnection track_connections = 4;
   */
  trackConnections: Location_TrackConnection[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.Location.Crossing crossings = 5;
   */
  crossings: Location_Crossing[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.TrackWithGeometry tracks = 6;
   */
  tracks: TrackWithGeometry[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.Location.TrackGroupWithGeometry track_groups = 7;
   */
  trackGroups: Location_TrackGroupWithGeometry[] = [];

  constructor(data?: PartialMessage<Location>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Location";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "junctions", kind: "message", T: Location_Junction, repeated: true },
    { no: 3, name: "buffer_stops", kind: "message", T: Location_BufferStop, repeated: true },
    { no: 4, name: "track_connections", kind: "message", T: Location_TrackConnection, repeated: true },
    { no: 5, name: "crossings", kind: "message", T: Location_Crossing, repeated: true },
    { no: 6, name: "tracks", kind: "message", T: TrackWithGeometry, repeated: true },
    { no: 7, name: "track_groups", kind: "message", T: Location_TrackGroupWithGeometry, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Location {
    return new Location().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Location {
    return new Location().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Location {
    return new Location().fromJsonString(jsonString, options);
  }

  static equals(a: Location | PlainMessage<Location> | undefined, b: Location | PlainMessage<Location> | undefined): boolean {
    return proto3.util.equals(Location, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.Location.Junction
 */
export class Location_Junction extends Message<Location_Junction> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: knop.ui.v1.model.Point coordinate = 2;
   */
  coordinate?: Point;

  /**
   * @generated from field: string connection_permanent = 3;
   */
  connectionPermanent = "";

  /**
   * @generated from field: string connection_left = 4;
   */
  connectionLeft = "";

  /**
   * @generated from field: string connection_right = 5;
   */
  connectionRight = "";

  constructor(data?: PartialMessage<Location_Junction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Location.Junction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coordinate", kind: "message", T: Point },
    { no: 3, name: "connection_permanent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "connection_left", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "connection_right", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Location_Junction {
    return new Location_Junction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Location_Junction {
    return new Location_Junction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Location_Junction {
    return new Location_Junction().fromJsonString(jsonString, options);
  }

  static equals(a: Location_Junction | PlainMessage<Location_Junction> | undefined, b: Location_Junction | PlainMessage<Location_Junction> | undefined): boolean {
    return proto3.util.equals(Location_Junction, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.Location.BufferStop
 */
export class Location_BufferStop extends Message<Location_BufferStop> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: knop.ui.v1.model.Point coordinate = 2;
   */
  coordinate?: Point;

  /**
   * @generated from field: string connection = 3;
   */
  connection = "";

  constructor(data?: PartialMessage<Location_BufferStop>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Location.BufferStop";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coordinate", kind: "message", T: Point },
    { no: 3, name: "connection", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Location_BufferStop {
    return new Location_BufferStop().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Location_BufferStop {
    return new Location_BufferStop().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Location_BufferStop {
    return new Location_BufferStop().fromJsonString(jsonString, options);
  }

  static equals(a: Location_BufferStop | PlainMessage<Location_BufferStop> | undefined, b: Location_BufferStop | PlainMessage<Location_BufferStop> | undefined): boolean {
    return proto3.util.equals(Location_BufferStop, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.Location.TrackConnection
 */
export class Location_TrackConnection extends Message<Location_TrackConnection> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: knop.ui.v1.model.Point coordinate = 2;
   */
  coordinate?: Point;

  /**
   * @generated from field: string connection0 = 3;
   */
  connection0 = "";

  /**
   * @generated from field: string connection1 = 4;
   */
  connection1 = "";

  constructor(data?: PartialMessage<Location_TrackConnection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Location.TrackConnection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coordinate", kind: "message", T: Point },
    { no: 3, name: "connection0", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "connection1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Location_TrackConnection {
    return new Location_TrackConnection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Location_TrackConnection {
    return new Location_TrackConnection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Location_TrackConnection {
    return new Location_TrackConnection().fromJsonString(jsonString, options);
  }

  static equals(a: Location_TrackConnection | PlainMessage<Location_TrackConnection> | undefined, b: Location_TrackConnection | PlainMessage<Location_TrackConnection> | undefined): boolean {
    return proto3.util.equals(Location_TrackConnection, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.Location.Crossing
 */
export class Location_Crossing extends Message<Location_Crossing> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: knop.ui.v1.model.Point coordinate = 2;
   */
  coordinate?: Point;

  /**
   * @generated from field: string connection_left_a = 3;
   */
  connectionLeftA = "";

  /**
   * @generated from field: string connection_left_b = 4;
   */
  connectionLeftB = "";

  /**
   * @generated from field: string connection_right_a = 5;
   */
  connectionRightA = "";

  /**
   * @generated from field: string connection_right_b = 6;
   */
  connectionRightB = "";

  constructor(data?: PartialMessage<Location_Crossing>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Location.Crossing";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "coordinate", kind: "message", T: Point },
    { no: 3, name: "connection_left_a", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "connection_left_b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "connection_right_a", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "connection_right_b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Location_Crossing {
    return new Location_Crossing().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Location_Crossing {
    return new Location_Crossing().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Location_Crossing {
    return new Location_Crossing().fromJsonString(jsonString, options);
  }

  static equals(a: Location_Crossing | PlainMessage<Location_Crossing> | undefined, b: Location_Crossing | PlainMessage<Location_Crossing> | undefined): boolean {
    return proto3.util.equals(Location_Crossing, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.Location.TrackGroupWithGeometry
 */
export class Location_TrackGroupWithGeometry extends Message<Location_TrackGroupWithGeometry> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 length_in_mm = 3;
   */
  lengthInMm = 0;

  /**
   * @generated from field: repeated knop.ui.v1.model.Track tracks = 4;
   */
  tracks: Track[] = [];

  /**
   * @generated from field: repeated knop.ui.v1.model.Point coordinates_from_source_to_target = 5;
   */
  coordinatesFromSourceToTarget: Point[] = [];

  constructor(data?: PartialMessage<Location_TrackGroupWithGeometry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.Location.TrackGroupWithGeometry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "length_in_mm", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "tracks", kind: "message", T: Track, repeated: true },
    { no: 5, name: "coordinates_from_source_to_target", kind: "message", T: Point, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Location_TrackGroupWithGeometry {
    return new Location_TrackGroupWithGeometry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Location_TrackGroupWithGeometry {
    return new Location_TrackGroupWithGeometry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Location_TrackGroupWithGeometry {
    return new Location_TrackGroupWithGeometry().fromJsonString(jsonString, options);
  }

  static equals(a: Location_TrackGroupWithGeometry | PlainMessage<Location_TrackGroupWithGeometry> | undefined, b: Location_TrackGroupWithGeometry | PlainMessage<Location_TrackGroupWithGeometry> | undefined): boolean {
    return proto3.util.equals(Location_TrackGroupWithGeometry, a, b);
  }
}

